import { useCallback } from 'react';

import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { ButtonBase } from '@mui/material';
import { usePostHog } from 'posthog-js/react';

import useUserDetails from '@/hooks/useUserDetails';

type RateAnswerProps = {
  prompt: string;
  response: any[];
  conversationId: string;
  version: number;
  rating: -1 | 0 | 1 | undefined;
  onRate: (rating: -1 | 1) => void;
};

const RateAnswer = ({
  prompt,
  response,
  conversationId,
  version,
  rating = 0,
  onRate
}: RateAnswerProps) => {
  const posthog = usePostHog();
  const { userEmail } = useUserDetails();
  const iconProps = {
    width: '20px',
    height: '20px'
  };
  const sendPosthogResponse = useCallback(
    (score: number) => {
      const posthogEvent = {
        email: userEmail,
        prompt,
        response,
        score,
        timestamp: new Date().toISOString(),
        thread_id: conversationId,
        version
      };
      posthog.capture('ai_chat_score', posthogEvent);
    },
    [conversationId, posthog, prompt, response, userEmail, version]
  );
  return (
    <>
      <ButtonBase
        disableRipple
        data-testid='thumb-up'
        disabled={rating === 1}
        sx={{
          '&.Mui-disabled': {
            opacity: 1
          }
        }}
        onClick={() => {
          const newRating = 1;
          onRate(newRating);
          sendPosthogResponse(newRating);
        }}
      >
        {rating === 1 ? <ThumbUpIcon sx={iconProps} /> : <ThumbUpOutlinedIcon sx={iconProps} />}
      </ButtonBase>
      <ButtonBase
        disableRipple
        data-testid='thumb-down'
        disabled={rating === -1}
        sx={{
          '&.Mui-disabled': {
            opacity: 1
          }
        }}
        onClick={() => {
          const newRating = -1;
          onRate(newRating);
          sendPosthogResponse(newRating);
        }}
      >
        {rating === -1 ? (
          <ThumbDownIcon sx={iconProps} />
        ) : (
          <ThumbDownOutlinedIcon sx={iconProps} />
        )}
      </ButtonBase>
    </>
  );
};

export default RateAnswer;
